import { media, style } from 'app/assets/styles'
import { Link } from 'app/common/link'
import React, { Component } from 'react'
import type { IntlShape } from 'react-intl'
import { FormattedMessage, injectIntl } from 'react-intl'
import { colors } from 'shared/assets/styles'
import {
    featureCodes,
    restaurantServices,
    restaurantStatus
} from 'shared/utils'
import styled from 'styled-components'
import type { Coordinates } from 'shared/store/store-locator'
import type { EventMetadata } from 'shared/store/metadata'
import type { RestaurantShortDTO } from 'shared/types'
import { AvailableServices } from './AvailableServices'
import { SmallText } from 'app/common/typography'
import { CcCartCheck } from 'app/ecommerce/click-and-collect/cart-check'
import type { RestaurantInfoCC } from 'app/common/restaurant/types'
import { FeatureToggle } from 'app/common/feature-toggle'
import { BagOnClick } from 'app/assets/icons'
import { IconButton } from 'app-v2/design-systems/components/inputs/button'
import { isMobile, isTablet } from 'react-device-detect'

const { yellow, grey30, lightWhite } = colors
const { BIRTHDAY_BOOKING, CLICK_AND_COLLECT } = restaurantServices

type Props = {
    origin: ?Coordinates,
    destination: ?Coordinates,
    metaDirection?: EventMetadata,
    services: Array<string>,
    deliverooUrl?: string,
    uberEatsUrl?: string,
    cacStatus?: string,
    restaurantParams?: RestaurantInfoCC,
    restaurantPath?: string,
    metaRestaurantSheet?: EventMetadata,
    className?: string,
    restaurant?: RestaurantShortDTO,
    intl: IntlShape
}

class ButtonsComponent extends Component<Props> {
    renderCCButton = () => {
        const { restaurant, restaurantParams } = this.props
        let ctaLabelKey = 'clickandcollect'
        if (
            //$FlowFixMe
            (restaurant?.services?.includes(restaurantServices.TABLE_ORDER) ||
                //$FlowFixMe
                restaurantParams?.services?.includes(
                    restaurantServices.TABLE_ORDER
                )) &&
            (isMobile || isTablet)
        ) {
            ctaLabelKey = 'restaurant.order.button'
        }
        return (
            <FormattedMessage id={ctaLabelKey}>
                {(text: string) => (
                    <CcButtonContainer>
                        <IconButton
                            icon={<BagOnClick size={15} />}
                            otherStyle={{ padding: '3px 6px' }}>
                            {text}
                        </IconButton>
                    </CcButtonContainer>
                )}
            </FormattedMessage>
        )
    }

    render() {
        const {
            services,
            restaurantParams,
            restaurantPath,
            metaRestaurantSheet,
            className,
            restaurant,
            deliverooUrl,
            uberEatsUrl,
            cacStatus,
            intl
        } = this.props
        const isRestaurantPage = className === 'restaurant'
        const borderColor = isRestaurantPage ? lightWhite : grey30
        const clickAndCollectAvailable =
            services.includes(CLICK_AND_COLLECT) &&
            (cacStatus === restaurantStatus.OPENED ||
                cacStatus === restaurantStatus.IMMINENT_CLOSING)
        const hasBirthday = services.includes(BIRTHDAY_BOOKING)
        const restaurantInfos = restaurant ? restaurant : restaurantParams

        return (
            <ButtonsContainer>
                <FeatureToggle feature={featureCodes.CLICK_AND_COLLECT}>
                    {clickAndCollectAvailable && (
                        <CcCartCheck restaurant={restaurantInfos}>
                            {this.renderCCButton()}
                        </CcCartCheck>
                    )}
                </FeatureToggle>
                {hasBirthday && restaurantInfos && (
                    <FormattedMessage id="storelocator.restaurant.button.birthday">
                        {(text: string) => (
                            <StyledLink
                                url={intl.formatMessage({
                                    id: 'routes.birthday'
                                })}
                                params={restaurantInfos}
                                color={yellow}
                                border={yellow}
                                className={className}
                                background="none">
                                {text}
                            </StyledLink>
                        )}
                    </FormattedMessage>
                )}
                <Border borderColor={borderColor} />
                <AvailableServices
                    services={services}
                    deliverooUrl={deliverooUrl}
                    uberEatsUrl={uberEatsUrl}
                    className={className}
                />
                {restaurantPath && (
                    <FormattedMessage id="storelocator.restaurant.button.restaurant">
                        {(text: string) => (
                            <StyledRestaurantLink
                                url={`${intl.formatMessage({
                                    id: 'routes.restaurant'
                                })}/${restaurantPath}`}
                                meta={metaRestaurantSheet}>
                                <StyledRestaurantLinkText>
                                    {text}
                                </StyledRestaurantLinkText>
                            </StyledRestaurantLink>
                        )}
                    </FormattedMessage>
                )}
            </ButtonsContainer>
        )
    }
}

const ButtonsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 5px 0;

    &.restaurant {
        ${media.medium`
        width: 90%;
    `}
    }
`

const StyledLink = styled(Link)`
    ${style.buttonSmall};
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    margin: 5px;
    height: 16px;
    min-width: 100px;
`

const Border = styled.div`
    border: solid 1px ${props => props.borderColor};
    border-left-width: 0;
    border-right-width: 0;
    border-top-width: 0;
    width: 100%;
`
const StyledRestaurantLink = styled(Link)`
    padding: 12px 0;
`

const StyledRestaurantLinkText = styled(SmallText)`
    text-decoration: underline;
`

const CcButtonContainer = styled.div`
    margin: 5px 0;
`

const Buttons = injectIntl(ButtonsComponent)

export { Buttons }
